export const defaultStages = [
  { key: "called", display: "Arandı" },
  { key: "unreachable", display: "Ulaşılamadı" },
  { key: "call_back_needed", display: "Tekrar Aranacak" },
  { key: "called_again", display: "Tekrar Arandı" },
  { key: "unreachable_info_sent", display: "Ulaşılamadı, bilgilendirme mesajı iletildi" },
  { key: "personal_account_no_info", display: "Kişisel hesap, bilgilendirme verilmedi" },
  { key: "meeting_link_received", display: "Toplantı linki alındı" },
  { key: "meeting_completed", display: "Toplantı gerçekleşti" },
]

import {
  ShoppingBagIcon,
  BriefcaseIcon,
  HeartIcon,
  HomeIcon,
  MusicalNoteIcon,
  CameraIcon,
  GlobeAltIcon,
  AcademicCapIcon,
  LightBulbIcon,
  SparklesIcon,
  ComputerDesktopIcon,
  WrenchScrewdriverIcon,
  FireIcon,
  BoltIcon,
  BeakerIcon,
  ArrowLeftStartOnRectangleIcon,
} from "@heroicons/react/20/solid"

export const BrandSectorsData = [
  { id: 1, name: "Moda ve Giyim", image: SparklesIcon, value: "fashion" },
  { id: 2, name: "Güzellik ve Kişisel Bakım", image: HeartIcon, value: "beauty_care" },
  { id: 3, name: "Teknoloji ve Elektronik", image: ComputerDesktopIcon, value: "tech_electronics" },
  { id: 4, name: "Sağlık ve Fitness", image: BeakerIcon, value: "health_fitness" },
  { id: 5, name: "Gıda ve İçecek", image: ShoppingBagIcon, value: "food_beverage" },
  { id: 6, name: "Otomotiv", image: BoltIcon, value: "automotive" },
  { id: 7, name: "Ev Dekorasyon ve Mobilya", image: HomeIcon, value: "home_furniture" },
  { id: 8, name: "E-ticaret ve Perakende", image: ShoppingBagIcon, value: "ecommerce_retail" },
  { id: 9, name: "Eğlence ve Medya", image: MusicalNoteIcon, value: "entertainment_media" },
  { id: 10, name: "Seyahat ve Turizm", image: GlobeAltIcon, value: "travel_tourism" },
  { id: 11, name: "Finans ve Sigorta", image: BriefcaseIcon, value: "finance_insurance" },
  { id: 12, name: "Eğitim ve Kariyer", image: AcademicCapIcon, value: "education_career" },
  { id: 13, name: "Anne ve Bebek", image: HeartIcon, value: "mother_baby" },
  { id: 14, name: "Hayvan Bakımı ve Ürünleri", image: HeartIcon, value: "pet_care" },
  {
    id: 15,
    name: "Yemek Tarifleri ve Restoranlar",
    image: FireIcon,
    value: "food_recipes_restaurants",
  },
  {
    id: 16,
    name: "Yeşil ve Sürdürülebilir Ürünler",
    image: ArrowLeftStartOnRectangleIcon,
    value: "sustainable_products",
  },
  {
    id: 17,
    name: "Etkinlikler ve Organizasyon",
    image: SparklesIcon,
    value: "events_organization",
  },
  { id: 18, name: "Spor ve Outdoor Aktiviteleri", image: LightBulbIcon, value: "sports_outdoor" },
  { id: 19, name: "Lüks ve Premium Ürünler", image: SparklesIcon, value: "luxury_premium" },
  { id: 20, name: "Telekomünikasyon", image: BoltIcon, value: "telecommunications" },
  {
    id: 21,
    name: "Gıda Takviyeleri ve Vitaminler",
    image: BeakerIcon,
    value: "supplements_vitamins",
  },
  {
    id: 22,
    name: "Temizlik ve Hijyen Ürünleri",
    image: WrenchScrewdriverIcon,
    value: "cleaning_hygiene",
  },
  { id: 23, name: "Emlak ve Gayrimenkul", image: HomeIcon, value: "real_estate" },
  {
    id: 24,
    name: "Bireysel ve Profesyonel Eğitim",
    image: AcademicCapIcon,
    value: "individual_professional_education",
  },
  { id: 25, name: "Kişisel Gelişim ve Wellbeing", image: HeartIcon, value: "personal_development" },
  { id: 26, name: "Sanat ve El Sanatları", image: LightBulbIcon, value: "art_crafts" },
  {
    id: 27,
    name: "Çocuk ve Gençlik Ürünleri",
    image: SparklesIcon,
    value: "children_youth_products",
  },
  {
    id: 28,
    name: "Eğlence Parkları ve Oyun Alanları",
    image: MusicalNoteIcon,
    value: "amusement_parks",
  },
  {
    id: 29,
    name: "Online Eğitim ve Dijital Kurslar",
    image: AcademicCapIcon,
    value: "online_education",
  },
  {
    id: 30,
    name: "Tarım ve Hayvancılık",
    image: ArrowLeftStartOnRectangleIcon,
    value: "agriculture_livestock",
  },
  {
    id: 31,
    name: "Yeşil Enerji ve Yenilenebilir Çözümler",
    image: FireIcon,
    value: "green_energy_solutions",
  },
  {
    id: 32,
    name: "Çevre Dostu Ürünler ve Geri Dönüşüm",
    image: ArrowLeftStartOnRectangleIcon,
    value: "eco_friendly_recycling",
  },
  { id: 33, name: "Mücevher ve Aksesuar", image: SparklesIcon, value: "jewelry_accessories" },
  { id: 34, name: "İş ve Ofis Ürünleri", image: BriefcaseIcon, value: "business_office_products" },
  {
    id: 35,
    name: "Yazılım ve Mobil Uygulamalar",
    image: ComputerDesktopIcon,
    value: "software_mobile_apps",
  },
  {
    id: 36,
    name: "Fotoğrafçılık ve Görsel Medya",
    image: CameraIcon,
    value: "photography_visual_media",
  },
  { id: 37, name: "Diğer", image: CameraIcon, value: "" },
]

export const BrandSubSectorsData = [
  { id: 1, name: "Dijital Pazarlama", value: "digital_marketing" },
  { id: 2, name: "Sosyal Medya Influencer", value: "social_media_influencer" },
  { id: 3, name: "Influencer Pazarlama", value: "influencer_marketing" },
  { id: 4, name: "Halkla İlişkiler", value: "public_relations" },
  { id: 5, name: "Reklam Yaratıcılığı", value: "advertising_creative" },
  { id: 6, name: "İçerik Üretimi", value: "content_creation" },
  { id: 7, name: "SEO/SEM", value: "seo_sem" },
  { id: 8, name: "Performans Pazarlama", value: "performance_marketing" },
  { id: 9, name: "Mobil Pazarlama", value: "mobile_marketing" },
  { id: 10, name: "Video/Fotoğraf Prodüksiyon", value: "video_photo_production" },
  { id: 11, name: "Etkinlik Ajansı", value: "event_agency" },
  { id: 12, name: "Marka Danışmanlığı ve Strateji", value: "brand_consulting_strategy" },
  { id: 13, name: "E-ticaret Satış ve Pazarlama", value: "ecommerce_sales_marketing" },
  { id: 14, name: "Kriz Yönetimi", value: "crisis_management" },
  { id: 15, name: "Blogger/YouTube Yönetimi", value: "blogger_youtube_management" },
  { id: 16, name: "Etkileşimli Pazarlama", value: "interactive_marketing" },
  { id: 17, name: "Pazarlama Otomasyonu", value: "marketing_automation" },
  { id: 18, name: "Veri Analitiği", value: "data_analytics" },
  { id: 19, name: "Yaratıcı Tasarım", value: "creative_design" },
  { id: 20, name: "Kampanya ve Influencer Yönetimi", value: "campaign_influencer_management" },
  { id: 21, name: "Özel Etkinlik Ajansı", value: "special_event_agency" },
  { id: 22, name: "Medya Planlama", value: "media_planning" },
  { id: 23, name: "Topluluk Yönetimi", value: "community_management" },
  { id: 24, name: "Omni-Channel Pazarlama", value: "omni_channel_marketing" },
  { id: 25, name: "Marka Deneyimi", value: "brand_experience" },
  { id: 26, name: "Product Placement ve Sponsorluk", value: "product_placement_sponsorship" },
  { id: 27, name: "Podcast ve Yeni Medya", value: "podcast_new_media" },
  { id: 28, name: "Moda", value: "fashion" },
  { id: 29, name: "Güzellik Bakımı", value: "beauty_care" },
  { id: 30, name: "Teknoloji ve Elektronik", value: "tech_electronics" },
  { id: 31, name: "Sağlık ve Fitness", value: "health_fitness" },
  { id: 32, name: "Gıda ve İçecek", value: "food_beverage" },
  { id: 33, name: "Otomotiv", value: "automotive" },
  { id: 34, name: "Ev Mobilyası", value: "home_furniture" },
  { id: 35, name: "E-ticaret Perakende", value: "ecommerce_retail" },
  { id: 36, name: "Eğlence ve Medya", value: "entertainment_media" },
  { id: 37, name: "Seyahat ve Turizm", value: "travel_tourism" },
  { id: 38, name: "Finans ve Sigorta", value: "finance_insurance" },
  { id: 39, name: "Eğitim ve Kariyer", value: "education_career" },
  { id: 40, name: "Anne ve Bebek", value: "mother_baby" },
  { id: 41, name: "Evcil Hayvan Bakımı", value: "pet_care" },
  { id: 42, name: "Yemek Tarifleri ve Restoranlar", value: "food_recipes_restaurants" },
  { id: 43, name: "Sürdürülebilir Ürünler", value: "sustainable_products" },
  { id: 44, name: "Etkinlik ve Organizasyon", value: "events_organization" },
  { id: 45, name: "Spor ve Outdoor", value: "sports_outdoor" },
  { id: 46, name: "Lüks ve Premium", value: "luxury_premium" },
  { id: 47, name: "Telekomünikasyon", value: "telecommunications" },
  { id: 48, name: "Takviyeler ve Vitaminler", value: "supplements_vitamins" },
  { id: 49, name: "Temizlik ve Hijyen", value: "cleaning_hygiene" },
  { id: 50, name: "Emlak", value: "real_estate" },
  { id: 51, name: "Bireysel ve Mesleki Eğitim", value: "individual_professional_education" },
  { id: 52, name: "Kişisel Gelişim", value: "personal_development" },
  { id: 53, name: "Sanat ve El Sanatları", value: "art_crafts" },
  { id: 54, name: "Çocuk ve Genç Ürünleri", value: "children_youth_products" },
  { id: 55, name: "Lunapark ve Eğlence Parkları", value: "amusement_parks" },
  { id: 56, name: "Online Eğitim", value: "online_education" },
  { id: 57, name: "Tarım ve Hayvancılık", value: "agriculture_livestock" },
  { id: 58, name: "Yeşil Enerji ve Çözümler", value: "green_energy_solutions" },
  { id: 59, name: "Çevre Dostu Geri Dönüşüm", value: "eco_friendly_recycling" },
  { id: 60, name: "Mücevher ve Aksesuar", value: "jewelry_accessories" },
  { id: 61, name: "İş ve Ofis Ürünleri", value: "business_office_products" },
  { id: 62, name: "Yazılım ve Mobil Uygulamalar", value: "software_mobile_apps" },
  { id: 63, name: "Fotoğrafçılık ve Görsel Medya", value: "photography_visual_media" },
  { id: 64, name: "Diğer", value: "" },
]
